import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "jss", "onClick"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import createStyles from "../createStyles";
import { fade } from "../theme/utils";
import { blueGray700 } from "../theme/colors";
var useStyles = createStyles({
  root: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: fade(blueGray700, 0.85)
  }
}, {
  name: 'Backdrop'
});

var Backdrop = function Backdrop(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    jss: jss
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "presentation",
    className: cn(classes.root, className),
    onClick: onClick
  }, props, {
    "data-qa": "backdrop"
  }));
};

Backdrop.propTypes = {
  className: PropTypes.string,
  jss: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]),
  onClick: PropTypes.func
};
export default Backdrop;